/** A count as the compact surfaces show it (search hub spec §5): above 99 it reads “99+”. */
export function formatCount(count: number): string {
  return count > 99 ? "99+" : String(count);
}
